import React, { useId } from 'react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const reactId = useId();
  const inputId = id || `checkbox-${reactId}`;

  return (
    <div className="space-y-2">
      <div className="flex items-start gap-3">
        <input
          id={inputId}
          type="checkbox"
          ref={ref}
          className={`h-5 w-5 rounded border-neutral-300 text-blue-600 focus:ring-blue-500 ${className}`.trim()}
          {...props}
        />
        {label && (
          <label htmlFor={inputId} className="text-sm text-neutral-800 leading-6">
            {label}
          </label>
        )}
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {helperText && !error && <p className="text-sm text-neutral-500">{helperText}</p>}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';
